module.exports = __webpack_public_path__ + "static/img/icon15.3ede07f9.png";